import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card card-flush py-4 mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder fs-6 text-gray-600 text-uppercase m-0" }, "Thí sinh")
], -1)
const _hoisted_4 = { class: "mb-3 w-100 mt-2" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 cursor-pointer align-items-baseline gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "mt-3 w-100 mb-5 ps-7"
}
const _hoisted_8 = { class: "form-label d-inline-flex align-items-center gap-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"280px","line-height":"1.5"} }, [
  /*#__PURE__*/_createTextVNode(" Phân loại ưu đãi "),
  /*#__PURE__*/_createElementVNode("b", null, "con GV/NV trường THPT"),
  /*#__PURE__*/_createTextVNode(" (theo quy định Nhà trường), mức giảm/học kỳ:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" • "),
  /*#__PURE__*/_createElementVNode("b", null, "Đối tượng 1"),
  /*#__PURE__*/_createTextVNode(": 3.630.000đ — mức cao nhất (VD con Ban Giám Hiệu / Giáo viên chủ nhiệm)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" • "),
  /*#__PURE__*/_createElementVNode("b", null, "Đối tượng 2"),
  /*#__PURE__*/_createTextVNode(": 2.725.000đ — mức trung bình"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" • "),
  /*#__PURE__*/_createElementVNode("b", null, "Đối tượng 3"),
  /*#__PURE__*/_createTextVNode(": 1.800.000đ — mức thấp nhất (VD con Giáo viên / Nhân viên) ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle text-primary cursor-pointer" }, null, -1)
const _hoisted_11 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 cursor-pointer align-items-baseline gap-3" }
const _hoisted_12 = {
  key: 1,
  class: "mt-3 w-100 mb-5 ps-7"
}
const _hoisted_13 = { class: "form-label d-inline-flex align-items-center gap-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"280px","line-height":"1.5"} }, [
  /*#__PURE__*/_createTextVNode(" Mức giảm thêm cho "),
  /*#__PURE__*/_createElementVNode("b", null, "con GV/NV UMT & Tập đoàn Kiến Á"),
  /*#__PURE__*/_createTextVNode(", tăng theo thâm niên công tác của phụ huynh:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" • "),
  /*#__PURE__*/_createElementVNode("b", null, "Dưới 2 năm"),
  /*#__PURE__*/_createTextVNode(": mức thấp nhất"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" • "),
  /*#__PURE__*/_createElementVNode("b", null, "Hơn 2 năm và dưới 5 năm"),
  /*#__PURE__*/_createTextVNode(": mức trung bình"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" • "),
  /*#__PURE__*/_createElementVNode("b", null, "Trên 5 năm"),
  /*#__PURE__*/_createTextVNode(": mức cao nhất ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle text-primary cursor-pointer" }, null, -1)
const _hoisted_16 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 cursor-pointer align-items-baseline gap-3" }
const _hoisted_17 = { class: "fv-row w-100 text-end d-flex justify-content-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, [
            _createVNode(_component_el_checkbox, {
              disabled: !_ctx.isEdit,
              class: "",
              modelValue: _ctx.islecturerchild,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.islecturerchild) = $event)),
              onChange: _cache[1] || (_cache[1] = e=>{
                if(e) {
                  _ctx.isstaffchild = false
                  _ctx.ispartnerchild = false
                  _ctx.personnelchild = null
                }
              }),
              value: 1
            }, null, 8, ["disabled", "modelValue"]),
            _createTextVNode(" Là con của giáo viên, nhân viên trường THPT ")
          ]),
          (_ctx.islecturerchild)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _createTextVNode(" Thuộc đối tượng "),
                  _createVNode(_component_el_tooltip, {
                    placement: "top",
                    effect: "dark"
                  }, {
                    content: _withCtx(() => [
                      _hoisted_9
                    ]),
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_el_select, {
                  class: "form-select-solid w-100",
                  placeholder: "Chọn thâm niên",
                  modelValue: _ctx.personnelchild,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.personnelchild) = $event)),
                  ref: "statusGraduated",
                  disabled: !_ctx.isEdit,
                  filterable: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
                  label: 'Đối tượng 1',
                  value: '1',
                },
                {
                  label: 'Đối tượng 2',
                  value: '2',
                },
                {
                  label: 'Đối tượng 3',
                  value: '3',
                },], (item, index) => {
                      return _createVNode(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("label", _hoisted_11, [
            _createVNode(_component_el_checkbox, {
              disabled: !_ctx.isEdit,
              class: "",
              modelValue: _ctx.isstaffchild,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isstaffchild) = $event)),
              onChange: _cache[4] || (_cache[4] = e=>{
                if(e) {
                  _ctx.islecturerchild = false
                  _ctx.ispartnerchild = false
                  _ctx.personnelchild = null

                }
              }),
              value: 1
            }, null, 8, ["disabled", "modelValue"]),
            _createTextVNode(" Là con của giảng viên, nhân viên UMT, Kiến Á ")
          ]),
          (_ctx.isstaffchild)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _createTextVNode(" Căn cứ thâm niên giảm thêm "),
                  _createVNode(_component_el_tooltip, {
                    placement: "top",
                    effect: "dark"
                  }, {
                    content: _withCtx(() => [
                      _hoisted_14
                    ]),
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_el_select, {
                  class: "form-select-solid w-100",
                  placeholder: "Chọn thâm niên",
                  modelValue: _ctx.personnelchild,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.personnelchild) = $event)),
                  ref: "statusGraduated",
                  disabled: !_ctx.isEdit,
                  filterable: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrPercent, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("label", _hoisted_16, [
            _createVNode(_component_el_checkbox, {
              disabled: !_ctx.isEdit,
              class: "",
              modelValue: _ctx.ispartnerchild,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ispartnerchild) = $event)),
              onChange: _cache[7] || (_cache[7] = e=>{
                if(e) {
                  _ctx.islecturerchild = false
                  _ctx.isstaffchild = false
                  _ctx.personnelchild = null
                }
              }),
              value: 1
            }, null, 8, ["disabled", "modelValue"]),
            _createTextVNode(" Là con của đối tác tập đoàn Kiến Á, đối tác trường UMT ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        (_ctx.isEdit)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "btn btn-secondary min-w-100px umt-btn-32",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.defaultData && _ctx.defaultData(...args)))
            }, "Trở lại"))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: "btn btn-primary min-w-100px umt-btn-32",
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changeEdit && _ctx.changeEdit(...args)))
        }, _toDisplayString(_ctx.isEdit ? "Lưu" : "Thay đổi"), 1)
      ])
    ])
  ]))
}